var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"accordion-selector-option",class:{selected: _vm.selected},on:{"click":function($event){return _vm.$emit('select',_vm.value)}}},[_c('label',{staticClass:"w-100"},[_vm._t("label")],2),(_vm.$slots.default)?_c('div',{staticClass:"description-box d-grid"},[_c('div',{staticClass:"description"},[_vm._t("default")],2)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }